import * as React from 'react'

function SearchIcon (props)
{
	const output =
	(
		<svg xmlns="http://www.w3.org/2000/svg" width={ 1024 } height={ 1024 }
			viewBox="0 0 1024 1024" { ...props }>
		<title>Recherche</title>
		<path fill="currentColor" d="M1014.294 968.29l-264.38-260.155c69.233-75.219 111.771-174.698 111.771-284.164C861.652 189.803 668.775 0 430.831 0S.01 189.803.01 423.971s192.877 423.971 430.821 423.971c102.808 0 197.102-35.56 271.168-94.678l265.406 261.181c12.932 12.74 33.927 12.74 46.859 0a32.278 32.278 0 00.03-46.155zM430.831 782.711c-201.326 0-364.533-160.613-364.533-358.74s163.207-358.74 364.533-358.74c201.328 0 364.533 160.613 364.533 358.74s-163.205 358.74-364.533 358.74z" />
		</svg>
	);

	return output;
}

export default SearchIcon
